import { CategoryCell } from '@tableau/catalog-ui-temp';
import { BodyCell } from '@tableau/widgets-datagrid';
import React from 'react';

import { StyledCellFormatter } from '~src/spacesPlatform/components/ListView/StyledCellWrapper';

export function CategoryPopover(): React.StatelessComponent<BodyCell.Props> {
  return StyledCellFormatter(
    function InnerCategoryCell(props: BodyCell.Props) {
      const data = props.row.data;

      const category = data['category'];
      const localizedCategory = data['localizedCategory'];
      const description = 'categoryDescription' in data && data['categoryDescription'] ? data['categoryDescription'] : 'built-in';

      return <CategoryCell categoryName={category} localizedCategoryName={localizedCategory} description={description} />;
    }
  );
}
